export default function useLanguageRegionCode() {
  return global.__AT_STORE__.languageRegionCode;
}
